/**
 * @description
 * headers to dispatch request batch detail
 */
export default [
    {
        text: '#',
        value: 'id',
        width: '1%',
    },
    {
        text: 'rut',
        value: 'sl_customer_rut',
        format: 'rut',
        width: '10%',
    },
    {
        text: 'cliente',
        value: 'sl_customer_alias_name',
        width: '20%',
    },
    {
        text: 'observación',
        value: 'observation',
        input: {
            type: 'text-field',
        },
    },
    {
        text: 'estado',
        value: 'g_state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    despachada: 'secondary lighten-3',
                    recepcionada: 'success lighten-3',
                    recepcionada_parcialmente: 'info lighten-3',
                    no_recepcionada: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
        input: {
            class: 'ma-0 pa-0',
            clearable: false,
            custom: 'g_state',
            renderItems: () => [
                {
                    state: 'Recepcionada',
                    id: 32,
                },
                {
                    state: 'Recepcionada parcialmente',
                    id: 33,
                },
                {
                    state: 'No recepcionada',
                    id: 34,
                },
            ],
            itemText: 'state',
            itemValue: 'id',
            label: 'Estado',
            returnObject: true,
            outline: false,
            type: 'select',
        },
        width: '20%',
    },
]
